import React from 'react';
import { FormattedMessage, useIntl } from '../../util/reactIntl';
import { LINE_ITEM_PROVIDER_COMMISSION } from '../../util/types';
import { formatMoney } from '../../util/currency';
import { getCurrentCountryPricing } from '../../util/countryDetection';
import css from './OrderBreakdown.module.css';

const LineItemCountryServiceFeeMaybe = props => {
  const { lineItems, isProvider, intl } = props;

  const countryServiceFee = lineItems.find(
    item => 
      item.code === LINE_ITEM_PROVIDER_COMMISSION && 
      item.countryCode && 
      !item.reversal
  );

  if (!countryServiceFee || !isProvider) {
    return null;
  }

  const { percentage, lineTotal, unitPrice, currency } = countryServiceFee;
  const countryConfig = getCurrentCountryPricing();
  
  // Don't show if hidden from provider
  if (countryServiceFee.hidden) {
    return null;
  }

  const formattedFee = formatMoney(intl, lineTotal);
  const feePercentage = Math.abs(percentage);

  return (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage
          id="OrderBreakdown.countryServiceFee"
          values={{
            percentage: feePercentage,
            country: countryConfig.countryName || countryServiceFee.countryCode
          }}
        />
      </span>
      <span className={css.itemValue}>{formattedFee}</span>
    </div>
  );
};

export default LineItemCountryServiceFeeMaybe; 